import PropTypes from 'prop-types';
import React from 'react';
import { Link, Message } from 'src/core/components';

import messages from './messages';

// eslint-disable-next-line no-unused-vars
const ReviewContainer = ({ detailsLink }) => (
  <Link href={detailsLink} bold>
    <Message message={messages.reviewAndOrder} />
  </Link>
);

ReviewContainer.propTypes = {
  detailsLink: PropTypes.string.isRequired,
};

export default ReviewContainer;
